// ADR 23.9.26u §7 — "New version available", until the learner says Reload.
//
// No timer, no auto-apply, no dismiss: a closed tab applies the update anyway,
// and the page never reloads under a learner who is mid-answer. `role="status"`
// is `ServiceModeBanner`'s live-region choice — polite, never stealing focus
// from an answer field.
//
// ADR 28.9.26d §1 — it wears the snackbar's look but does not join its queue:
// an indefinite entry at the head of a FIFO would block every snackbar behind
// it until the learner reloads. `app/Shell.tsx` passes it to `SnackbarHost` as
// the **pinned** slot, so it sits in the snackbar's column above the current
// entry and the two cannot overlap; it has no `fixed` wrapper of its own.
// Idle, it renders `null`.

import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'

import { SnackbarSurface } from '../ui/feedback'
import { applyUpdate, subscribeUpdate, updateAvailable } from './register'

export function UpdateToast() {
  const { t } = useTranslation()
  const available = useSyncExternalStore(subscribeUpdate, updateAvailable)
  if (!available) return null
  return (
    <SnackbarSurface action={{ label: t('pwa_update_reload'), onPress: applyUpdate }}>
      <p role="status">{t('pwa_update_available')}</p>
    </SnackbarSurface>
  )
}
